import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

// MUI
import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  FormControlLabel,
  CssBaseline,
  Checkbox,
  Box,
  Grid,
  Typography,
  Container,
} from "@mui/material";
import { themeOptions } from "../../theme";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { userLogin } from "../../redux/actions/user-action";

// Images
import imgRightPlaceholder from "../../assets/images/login-person-placeholder.png";
import imgBg from "../../assets/images/login-bg.png";
import imgLogo from "../../assets/images/logo.png";

// Components
import StandardInput from "../../components/TextFields/StandardInput";
import MaterialButton from "../../components/Buttons";

import { toast } from "react-toastify";

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = createTheme(themeOptions);

  // Selector
  const { loading } = useSelector((state) => state.userLoginReducer);

  const myStyles = makeStyles({
    mainContainer: {
      width: "100%",
      minHeight: "100vh",
      height: "auto",
      position: "relative",
      backgroundColor: "#F5F5F5",
      backgroundImage: `url(${imgBg})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "80%",
      backgroundPosition: "right top",
      display: "flex",
      alignItems: "center",
      padding: "20px 0px",
      [theme.breakpoints.down("md")]: {
        backgroundSize: "cover",
      },
    },
    glassLoginForm: {
      widht: "100%",
      height: "auto",
      background:
        "linear-gradient(238.32deg, #FFFFFF 3.26%, rgba(255, 255, 255, 0.5) 44.67%, #FFFFFF 100%)",
      backdropFilter: "blur(10px)",
      borderRadius: "20px",
      padding: "50px 30px ",
    },
    logoImage: {
      width: "80px",
      height: "objectFit",
      marginBottom: "20px",
    },
    imgRightSide: {
      width: "90%",
      height: "objectFit",
    },
  });

  const classes = myStyles();

  // State
  const [values, setValues] = useState({
    email: "",
    password: "",
    checked: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };

  const handleRememberMe = (e) => {
    setValues((pre) => {
      return {
        ...pre,
        checked: e.target.checked,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (values.email === "") {
      return toast.error("Emaill address is required", { toastId: "error1" });
    } else if (
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(values.email)
    ) {
      return toast.error("Email address is invalid", { toastId: "error1" });
    } else if (values.password === "") {
      return toast.error("Password is required", { toastId: "error1" });
    }

    dispatch(userLogin(values, navigate));
  };

  useEffect(() => {
    let getRemeberMe = localStorage.getItem("credentials");

    if (getRemeberMe != null) {
      getRemeberMe = JSON.parse(getRemeberMe);

      setValues((pre) => {
        return {
          ...pre,
          email: getRemeberMe.email,
          password: getRemeberMe.password,
          checked: getRemeberMe.checked,
        };
      });
    }

    console.log("getRemeberMe", getRemeberMe);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box className={classes.mainContainer}>
        <Container maxWidth="xl">
          <Grid container justifyContent="space-between">
            <Grid item xs={12} md={5}>
              <Box className={classes.glassLoginForm}>
                <Box sx={{ textAlign: "center" }}>
                  <img className={classes.logoImage} src={imgLogo} alt='img-logo' />
                  <Typography
                    variant="h4"
                    color="#06623B"
                    fontWeight={700}
                    gutterBottom
                  >
                    Sign in
                  </Typography>
                </Box>
                <form onSubmit={handleSubmit}>
                  <StandardInput
                    label="Email"
                    name="email"
                    type="email"
                    placeholder="emialid@legendstourgolf.com"
                    value={values.email}
                    onChange={handleChange}
                  />
                  <StandardInput
                    label="Password"
                    name="password"
                    type="password"
                    placeholder="************"
                    value={values.password}
                    onChange={handleChange}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "30px",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          value="remember"
                          color="primary"
                          onChange={handleRememberMe}
                          checked={values.checked}
                        />
                      }
                      label="Remember me"
                    />
                    <Link
                      style={{
                        color: "#06623B",
                        textDecoration: "none",
                        fontSize: "16px",
                        fontWeight: 400,
                      }}
                      to="/forgetPassword"
                    >
                      Forgot password?
                    </Link>
                  </Box>

                  <MaterialButton
                    type="submit"
                    label="Sign in"
                    disabled={loading}
                  />
                </form>
              </Box>
            </Grid>
            <Grid item xs={0} display={{ xs: "none", md: "block" }} md={5}>
              <img
                src={imgRightPlaceholder}
                alt="Golf Player"
                className={classes.imgRightSide}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
